import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc206360"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "happy"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "happy-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "精彩瞬间")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "happy-des" }, "单击任一图片放大显示", -1))

import { ref, reactive } from "vue";
import router from "@/router/index";
import store from "@/store/index";
import { useStore } from "@/store/index";

interface ActivityImage {
  imgUrl: string,
  thumbnailUrl: string,
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

var imageList: ActivityImage[] = [];

var imgUrlList: string[] = [];
var thumbnailUrlList: string[] = [];

var activityId = ref('');

const bindData = reactive({
  thumbnailUrlList: thumbnailUrlList,
  imgUrlList: imgUrlList,
});
var id = router.currentRoute.value.params.id || activityId.value || '153552d6c98143c6b76b767f4e661b05';
if (typeof id == "string") {
  store.dispatch("frontInvestModule/listActivityImage", { id: id }).then(
    (data) => {
      //成功
      imageList = data.result
      bindData.thumbnailUrlList = imageList.map(image => image.thumbnailUrl);
      bindData.imgUrlList = imageList.map(image => image.imgUrl);
    },
    (error) => {
      console.log(error.msg);
    }
  );
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(bindData).thumbnailUrlList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_el_container, { class: "happy-imgs" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).thumbnailUrlList, (url, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "happy-imgs-p",
                  key: index
                }, [
                  _createVNode(_component_el_image, {
                    style: {"width":"100px","height":"100px"},
                    src: url,
                    "preview-src-list": _unref(bindData).imgUrlList,
                    "initial-index": index,
                    fit: "cover"
                  }, null, 8, ["src", "preview-src-list", "initial-index"])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})